import {typeExport} from "../../../../redux/store/type";
import store from "../../../../redux/store";

const reducerSplashGetAllData = (state = {
    RestaurantBasketCheck: false,
    FoodItem: null,
    CartList: [],
    StoreId: 0,
    StoreName: '',
    PriceAll: 0,
    DiscountAll: 0,
    error: false,
    user: null,
    token: null,
    tokenMahaleh: null,
    tokenLaravel: null,
    isLoading: false,
    NoInternetDialog: false,
    results: null,

    isLoadingSaina: false,
    NoInternetDialogSaina: false,
    resultsSaina: null,

    resultsShahrdar: null,
    isLoadingShahrdar: false,
    NoInternetDialogShahrdar: false,

    results_City: null,
    showDialohCity: false,
    Rtl: false,
    Lang: 'en',
    NotifUser: 0,
    token_fb: null,
    Background: null,
    Connection: true,
    Location: null,
    CenterLocation: null,

    ListNotSendMyApply: [],
    indexListNotSendMyApply: 0,

    NotSendListOperatorApply: [],
    indexNotSendListOperatorApply: 0,

    ListNotSendRegisterComplaints: [],
    indexListNotSendRegisterComplaints: 0,
    TypeLogin: 1,

    idCity: 0,
    item_count: 10,

}, action) => {
    let data = null;
    const newState = {...state,};

    switch (action.type) {
        case typeExport.SPLASH_SERVICE_REFRESH:
            return {
                ...state,
                NoInternetDialog: false,
                showDialohCity: false,
                results: null,

                error: action.error,
                isLoading: action.isLoading,
            };

        case typeExport.SPLASH_SERVICE_PENDING_Background:
            return {
                ...state,
                isLoadingBackground: action.isLoadingBackground,
            };
        case typeExport.SPLASH_SERVICE_ERROR_Background:
            return {
                ...state,
                NoInternetDialogBackground: action.NoInternetDialogBackground,
            };
        case typeExport.SPLASH_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialog: false,
                showDialohCity: false,
                // results: null,

                error: action.error,
                isLoading: action.isLoading,
            };
        case typeExport.SPLASH_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialog: true,
                showDialohCity: false,
                // results: null,

                error: action.error,
                isLoading: action.isLoading,
            };
        case typeExport.SPLASH_SERVICE_SUCCESS:

            return {
                ...state,
                results: action.results,
                NoInternetDialog: false,
                showDialohCity: false,
                isLoading: action.isLoading,

                /*     token: action.token,
                     user: action.user,*/
            };

        case typeExport.SPLASH_SERVICE_PENDING_Saina:
            return {
                ...state,
                NoInternetDialogSaina: false,
                // resultsSaina: null,

                error: action.error,
                isLoadingSaina: action.isLoadingSaina,
            };
        case typeExport.SPLASH_SERVICE_ERROR_Saina:
            return {
                ...state,
                NoInternetDialogSaina: true,
                showDialohCitySaina: false,
                //  resultsSaina: null,

                error: action.error,
                isLoadingSaina: action.isLoadingSaina,
            };
        case typeExport.SPLASH_SERVICE_SUCCESS_Saina:

            return {
                ...state,
                resultsSaina: action.resultsSaina,
                NoInternetDialogSaina: false,

                isLoadingSaina: action.isLoadingSaina,
                CenterLocation: action.resultsSaina && action.resultsSaina.result && action.resultsSaina.result.info ? {
                    latitude: action.resultsSaina.result.info.latitude,
                    longitude: action.resultsSaina.result.info.longitude
                } : null,

            };


        case typeExport.SPLASH_SERVICE_PENDING_Shahrdar:
            return {
                ...state,
                NoInternetDialogShahrdar: false,
                resultsShahrdar: null,

                error: action.error,
                isLoadingShahrdar: action.isLoadingShahrdar,
            };
        case typeExport.SPLASH_SERVICE_ERROR_Shahrdar:
            return {
                ...state,
                NoInternetDialogShahrdar: true,
                showDialohCityShahrdar: false,
                resultsShahrdar: null,

                error: action.error,
                isLoadingShahrdar: action.isLoadingShahrdar,
            };
        case typeExport.SPLASH_SERVICE_SUCCESS_Shahrdar:

            return {
                ...state,
                resultsShahrdar: action.resultsShahrdar,
                NoInternetDialogShahrdar: false,

                isLoadingShahrdar: action.isLoadingShahrdar,
                CenterLocation: action.resultsShahrdar && action.resultsShahrdar.result && action.resultsShahrdar.result.info ? {
                    latitude: action.resultsShahrdar.result.info.latitude,
                    longitude: action.resultsShahrdar.result.info.longitude
                } : null,

            };
        case typeExport.SPLASH_SERVICE_PENDING_125:
            return {
                ...state,
                NoInternetDialog125: false,
                results125: null,

                error: action.error,
                isLoading125: action.isLoading125,
            };
        case typeExport.SPLASH_SERVICE_ERROR_125:
            return {
                ...state,
                NoInternetDialog125: true,
                showDialohCity125: false,
                results125: null,

                error: action.error,
                isLoading125: action.isLoading125,
            };
        case typeExport.SPLASH_SERVICE_SUCCESS_125:
            return {
                ...state,
                results125: action.results125,
                NoInternetDialog125: false,

                isLoading125: action.isLoading125,

            };

        case typeExport.SPLASH_SERVICE_PENDING_CITY:
            return {
                ...state,
                NoInternetDialogCity: false,
                showDialohCity: false,
                resultsCity: null,

                error: action.error,
                isLoadingCity: action.isLoadingCity,
            };
        case typeExport.SPLASH_SERVICE_ERROR_CITY:
            return {
                ...state,
                NoInternetDialog: true,
                showDialohCity: false,
                resultsCity: null,

                error: action.error,
                isLoadingCity: action.isLoadingCity,
            };
        case typeExport.SPLASH_SUCCESS_GET_CITY_DATA:
            return {
                ...state,
                NoInternetDialog: false,
                results_City: action.results_City,
                showDialohCity: true,
                isLoading: action.isLoading,
            };
        case typeExport.SPLASH_TOKEN:
            return {
                ...state,
                token: action.token,
            };
        case typeExport.SPLASH_TOKEN_MAHALEH:
            return {
                ...state,
                tokenMahaleh: action.token,
            };
        case typeExport.SPLASH_TOKEN_LARAVEL:
            return {
                ...state,
                tokenLaravel: action.token,
            };
        case typeExport.SPLASH_USER:
            return {
                ...state,
                user: action.user,
            };
        case typeExport.SPLASH_CITY:
            return {
                ...state,
                idCity: action.idCity,
            };

        case typeExport.SPLASH_WALLET:
            const newStateWALLET = {...state,};
            //sub=0 add=1 set=2
            switch (action.typeWallet) {

                case 0:
                    newStateWALLET.wallet = newStateWALLET.wallet - action.wallet
                    break;

                case 1:
                    newStateWALLET.wallet = newStateWALLET.wallet + action.wallet
                    break;

                case 2:
                    newStateWALLET.wallet = action.wallet
                    break;

            }


            return newStateWALLET;

        case typeExport.SERVICE_ADD_CART:
            if (newState.StoreId === 0 || newState.StoreId === action.product.restaurant_id) {
                newState.RestaurantBasketCheck = false
                newState.StoreId = action.product.restaurant_id;
                newState.StoreName = action.product.restaurant_name;

                let idx = newState.CartList.findIndex(obj => obj.id === action.product.id);

                newState.PriceAll += action.product.price;
                newState.DiscountAll += action.product.price * (action.product.discount / 100);
                if (idx !== -1) {
                    newState.CartList[idx].count_cart += 1;
                    newState.CartList = [...newState.CartList];
                } else {
                    data = [...newState.CartList, {...action.product, "count_cart": 1}]
                    newState.CartList = data
                }

            } else {
                if (newState.RestaurantBasketCheck) {
                    newState.CartList = [];
                    newState.PriceAll = 0;
                    newState.DiscountAll = 0;
                    newState.RestaurantBasketCheck = false;
                    newState.StoreId = action.product.restaurant_id;
                    newState.StoreName = action.product.restaurant_name;

                    let idx = newState.CartList.findIndex(obj => obj.id === action.product.id);

                    newState.PriceAll += action.product.price;
                    newState.DiscountAll += action.product.price * (action.product.discount / 100);
                    if (idx !== -1) {
                        newState.CartList[idx].count_cart += 1;
                        newState.CartList = [...newState.CartList];
                    } else {
                        data = [...newState.CartList, {...action.product, "count_cart": 1}]
                        newState.CartList = data
                    }
                } else {
                    newState.RestaurantBasketCheck = true
                }
                // newState.RestaurantBasketCheck = true
                newState.FoodItem = action.product


            }


            return newState;


        case typeExport.SERVICE_SUB_CART:

            newState.RestaurantBasketCheck = false

            let idx = newState.CartList.findIndex(obj => obj.id === action.product.id);
            //    let idx = newState.CartList.find(obj => obj.id === action.product.id);

            if (idx !== -1) {
                newState.PriceAll -= action.product.price
                newState.DiscountAll -= action.product.price * (action.product.discount / 100);

                if (newState.CartList[idx].count_cart > 1) {
                    newState.CartList[idx].count_cart -= 1
                    newState.CartList = [...newState.CartList];
                } else {
                    newState.CartList.splice(idx, 1);

                    if (newState.CartList.length === 0)
                        newState.StoreId = 0;
                }
            }


            return newState;


        case typeExport.SERVICE_PRICE_ALL:

            return state;

        case typeExport.SERVICE_CLEAR_ALL_CART:
            const newStateSubClear = {...state,};
            newStateSubClear.CartList = [];
            newStateSubClear.PriceAll = 0
            newStateSubClear.DiscountAll = 0
            return newStateSubClear;


        case typeExport.SERVICE_CHANGE_ITEM_DISCOUNT_FIRST:
            newState.results.first_buy_discount = null;
            return newState;

        case typeExport.SERVICE_RestaurantBasketCheck:

            newState.RestaurantBasketCheck = action.data
            return newState;

        case typeExport.SERVICE_Rtl:
            return {
                ...state,
                Rtl: action.data,
            };

        case typeExport.SERVICE_Lang:
            return {
                ...state,
                Lang: action.data,
            };

        case typeExport.SERVICE_Background:
            return {
                ...state,
                Background: action.data,
            };
        case typeExport.SERVICE_ChangeNotifUser:
            // return {
            //     ...state,
            //     NotifUser: action.data,
            // };
            newState.results.user.notify_status = action.data ? 1 : 0

            return newState;

        case typeExport.SERVICE_TokenFirebase:
            return {
                ...state,
                token_fb: action.data,
            };
        case typeExport.SERVICE_STATE:
            return {
                ...state,
                STATE: action.STATE,
            };

        case typeExport.SERVICE_Connection:
            return {
                ...state,
                Connection: action.Connection,

            };
        case typeExport.SERVICE_ConnectionType:
            return {
                ...state,
                ConnectionType: action.ConnectionType,

            };
        case typeExport.SERVICE_Location:
            return {
                ...state,
                Location: action.Location,

            };
        case typeExport.SERVICE_CenterLocation:
            return {
                ...state,
                CenterLocation: action.Location,

            };

        case typeExport.SERVICE_TypeLogin:
            return {
                ...state,
                TypeLogin: action.TypeLogin,

            };
        case typeExport.SERVICE_ListNotSendMyApply:

            return {
                ...state,
                ListNotSendMyApply: action.ListNotSendMyApply,
                indexListNotSendMyApply: action.indexListNotSendMyApply,

            };
        case typeExport.SERVICE_NotSendListOperatorApply:
            return {
                ...state,
                NotSendListOperatorApply: action.NotSendListOperatorApply,
                indexNotSendListOperatorApply: action.indexNotSendListOperatorApply,

            };

        case typeExport.SERVICE_ListNotSendRegisterComplaints:
            return {
                ...state,
                ListNotSendRegisterComplaints: action.ListNotSendRegisterComplaints,
                indexListNotSendRegisterComplaints: action.indexListNotSendRegisterComplaints,

            };
        case typeExport.SERVICE_NameDynamic:
            console.log("requestLogin=>SERVICE_NameDynamic", action)
            return {
                ...state,
                [action.name]: action.data,
            };
        default:
            return state;
    }
}

export default reducerSplashGetAllData;
